import React, { useState } from "react";
import "./Login.css";

import { bookizapLogo } from "../../../Assets/Icons/IconsIndex";
import LoginForm from "./LoginForm";
import OTPVerification from "./OtpPage/OTPVerification";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();


  return (
    <div className="flex flex-col items-center justify-center h-screen">
      {showOtpModal ? (
        <OTPVerification
          email={email}
          otp={otp}
          setOtp={setOtp}
          onSuccess={() => {
            navigate("/");
          }}
          onClose={() => setShowOtpModal(false)}
        />
      ):(
          <LoginForm
        email={email}
        setEmail={setEmail}
        setShowOtpModal={setShowOtpModal}
      />
      )}

    </div>
  );
};

export default Login;
